module.exports = __webpack_public_path__ + "static/media/0.6e535079.jpeg";